var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIco({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 3.37628,
    fill: "#BE8976",
    fillOpacity: 0.1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.47192 16.4106L7.58984 15.5285L11.1182 12.0002L7.58984 8.47192L8.47192 7.58984L12.0002 11.1182L15.5285 7.58984L16.4106 8.47192L12.8823 12.0002L16.4106 15.5285L15.5285 16.4106L12.0002 12.8823L8.47192 16.4106Z",
    fill: "#BE8976"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIco);
export default __webpack_public_path__ + "static/media/CloseIco.7197a6c06fc4fe40baf8d7eda23efe81.svg";
export { ForwardRef as ReactComponent };